<style lang="scss">
.slide-14 {
  background-image: url(../../../assets/module3/slide14/background-01.jpg);
  background-position: center;
  background-size: cover;
  padding-right: 0;

  h1,
  h2 {
    display: flex;
    flex-direction: column;
  }
  h1 {
    span {
      font-size: 52px;
      color: #3b7fc2;
      &:nth-child(1) {
        transform: rotate(-3deg);
      }
      &:nth-child(2) {
        transform: rotate(-3deg) translateX(-15px);
      }
      &:nth-child(3) {
        padding-top: 10px;
        transform: rotate(-1deg) translateX(10px);
      }
    }
  }
  h2 {
    transform: rotate(-3deg);
    span {
      font-size: 50px;
      line-height: 60px;
      margin: 0;
      color: #b1be38;
      &:nth-child(2) {
        transform: translateX(-20px);
      }
      &:nth-child(3) {
        transform: translateX(50px);
      }
    }
  }
  .h2 {
    position: absolute;
    right: 402px;
    top: 639px;
  }

  h3 {
    color: #d29908;
    font-size: 33px;
  }
  .h3 {
    position: absolute;
    bottom: 59px;
    left: 200px;
    text-align: center;
    right: 0;
  }

  .pages {
    box-sizing: border-box;
    width: 100%;
    padding-top: 130px;
    padding-right: 0;
  }

  .frank {
    z-index: 0;
  }

  .pages {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }

  .heading1,
  .heading2 {
    font-size: 40px;
    margin-bottom: 40px;
    width: 75%;
  }
  .heading3,
  .heading4 {
    font-size: 100px;
    color: #3b7fc2;
    transform: rotate(-10deg);
  }
  .heading4 {
    margin-left: 80px;
  }
  .number {
    font-size: 200px;
    margin-left: 200px;
    color: #e30613;
  }
  .play-button {
    margin-top: 185px;
    margin-right: -208px;
    img {
      transform: scale(0.2);
    }
  }
  video {
    outline: none !important;
    position: absolute;
    // top: 224px;
    top: 134px;
    left: 1033px;
    z-index: 1;
    width: 820px;
    height: 459px;
    background: black;
    border-radius: 23px;
  }
}
</style>

<template>
  <div class="slide-14">
    <transition name="fadeRight" appear>
      <img
        class="delay-3 video"
        v-show="slideIndex == 13"
        src="@/assets/module3/slide14/video-01.png"
      />
    </transition>
    <transition name="fadeUp" appear>
      <img
        class="chars delay-2"
        v-show="slideIndex == 13"
        src="@/assets/module3/slide14/armando-01.png"
      />
    </transition>
    <div class="pages">
      <div class="page page-left">
        <transition name="fadeLeft" appear>
          <div v-show="slideIndex == 13">
            <h1 v-html="$t('module3.slide14.heading1')"></h1>
          </div>
        </transition>

        <transition name="fadeRight" appear>
          <div class="delay-4 h2" v-show="slideIndex == 13">
            <h2 v-html="$t('module3.slide14.heading2')"></h2>
          </div>
        </transition>
      </div>
      <div class="page page-right">
        <transition name="fade">
          <video
            v-if="showVideo"
            :src="videoURL"
            autoplay
            controls
            ref="video"
          ></video>
        </transition>
        <transition name="fadeUp" appear>
          <div v-show="slideIndex == 13">
            <div class="play-button">
              <a href="" class="button" @click.prevent="playVideo(videoID)">
                <img src="@/assets/module3/slide14/button_play.png" />
              </a>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <transition name="fadeUp" appear>
      <div class="delay- h3" v-show="slideIndex == 13">
        <h3 v-html="$t('module3.slide14.heading3')"></h3>
      </div>
    </transition>
  </div>
</template>

<script>
import { log } from "../../../utils/log";
import vidEnd from "../../../utils/vid";

export default {
  data() {
    return {
      showVideo: false,
      videoURL:
        window?.CF_EBOOK_VARS?.videos?.book_3_video_3?.hd_large?.url ||
        "https://player.vimeo.com/external/372856691.hd.mp4?s=3769c14b17a089b0cb20f3a3e3f85cf3dae9aabb&profile_id=175",
      videoID:
        window?.CF_EBOOK_VARS?.videos?.book_1_video_3?.video_id || "test_id"
    };
  },
  props: ["slideIndex"],
  methods: {
    playVideo(id) {
      log.videoView(id);
      this.showVideo = true;
      vidEnd(this);
    }
  }
};
</script>
